import { render } from "./MxScore.vue?vue&type=template&id=b87ef87c&scoped=true"
import script from "./MxScore.vue?vue&type=script&lang=js"
export * from "./MxScore.vue?vue&type=script&lang=js"

import "./MxScore.vue?vue&type=style&index=0&id=b87ef87c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b87ef87c"]])

export default __exports__